export default {"src":"/_next/static/media/warrantyB.36a447d0.svg","height":13,"width":11};